var _circle, _mask, _path, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThirdMugAngle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 54,
    viewBox: "0 0 64 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    transform: "rotate(90 24 24)",
    stroke: "#CCCCCC",
    strokeWidth: 4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_13046_25429",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 28C64 30.2091 62.2091 32 60 32L46 32L46 16L60 16C62.2091 16 64 17.7909 64 20L64 28Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 28C68 32.4183 64.4183 36 60 36L45 36L47 28L60 28L68 28ZM45 12L60 12C64.4183 12 68 15.5817 68 20L60 20L47 20L45 12ZM60 12C64.4183 12 68 15.5817 68 20L68 28C68 32.4183 64.4183 36 60 36L60 28L60 20L60 12ZM45 36L45 12L47 20L47 28L45 36Z",
    fill: "#CCCCCC",
    mask: "url(#path-2-inside-1_13046_25429)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 48,
    r: 6,
    fill: "#3D98F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdMugAngle);
export default __webpack_public_path__ + "static/media/third-mug-angle.790b4be27f9171ac660123f9ca53818f.svg";
export { ForwardRef as ReactComponent };